/* ============================================================
   PROMARINE — NightTheme FAB controller
   Click en lengüeta → FAB se desliza, espera 3s, vuelve a ocultarse
   Agregar en: Assets → promarine-nighttheme-tab.js
   En theme.liquid antes de </body>:
   <script src="{{ 'promarine-nighttheme-tab.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  var PEEK_DURATION = 3000; // ms que el FAB permanece visible
  var hideTimer = null;

  function getIcon() {
    var theme = document.documentElement.getAttribute('data-theme');
    return theme === 'dark' ? '☽' : '☀';
  }

  function peek() {
    var fab = document.getElementById('nt-fab');
    var tab = document.getElementById('nt-tab');
    if (!fab) return;

    // Mostrar FAB, ocultar lengüeta
    fab.classList.add('nt-peek');
    if (tab) tab.classList.add('nt-hidden');

    // Limpiar timer anterior si había
    if (hideTimer) clearTimeout(hideTimer);

    // Volver a ocultar después de PEEK_DURATION
    hideTimer = setTimeout(function () {
      fab.classList.remove('nt-peek');
      if (tab) {
        tab.classList.remove('nt-hidden');
        tab.textContent = getIcon(); // actualizar ícono por si cambió el tema
      }
    }, PEEK_DURATION);
  }

  function init() {
    var fab = document.getElementById('nt-fab');
    if (!fab) return;

    // Crear la lengüeta
    var tab = document.createElement('div');
    tab.id = 'nt-tab';
    tab.setAttribute('role', 'button');
    tab.setAttribute('aria-label', 'Cambiar tema');
    tab.textContent = getIcon();
    document.body.appendChild(tab);

    // Click en lengüeta → mostrar FAB
    tab.addEventListener('click', function () {
      peek();
    });

    // Si el usuario hace click en el FAB, reiniciar el timer
    // (para que no se esconda mientras interactúa)
    fab.addEventListener('click', function () {
      if (hideTimer) clearTimeout(hideTimer);
      // Actualizar ícono de la lengüeta después del cambio de tema
      hideTimer = setTimeout(function () {
        fab.classList.remove('nt-peek');
        tab.classList.remove('nt-hidden');
        tab.textContent = getIcon();
      }, PEEK_DURATION);
    });

    // Actualizar ícono cuando cambia el tema desde afuera
    window.addEventListener('nighttheme:change', function () {
      tab.textContent = getIcon();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
